import React from 'react'
import { View, StyleSheet } from 'react-native'
import { Txt, Button } from '..'
import { reloadApp } from '../../tools/general'

const ErrorPage = () => {
  return (
    <View style={styles.container}>
      <Txt
        text='Something went wrong, please reload the app'
        identity='h4'
        style={styles.text}
      />
      <Button
        title='Reload App'
        onPress={reloadApp}
        style={styles.button}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 20
  },
  text: {
    textAlign: 'center',
    marginBottom: 15
  },
  button: {
    minWidth: 150
  }
})

export default ErrorPage
